import React from "react";
import { useApp } from "../../context/AppContext";
import { Building2 } from "lucide-react";
import { BranchManagerPanel } from "../../components/admin/BranchManagerPanel";

/* 分公司管理（/admin/branches）—— 系统管理 → 分公司管理
 *
 * 需求背景：原先「分公司管理」是「账号权限」页顶部按钮堆里的弹窗，入口深。现独立成页。
 * 数据与操作完全沿用原逻辑（GET/POST/DELETE /branches），见 BranchManagerPanel 的说明。
 *
 * 走查修正（2026-10-13）：页面改为**常规列表页**——顶部搜索 / 重置 / 刷新，右上「添加分公司」按钮
 * 弹窗录入（不再把输入框平铺在列表下）；并按用户要求**去掉页面上的说明性副标题**。
 * 标题保留 h1，但由 .app-page-content 统一转成 sr-only（可见标题由面包屑承担），与「通信设置」等页一致。
 */
export default function BranchesManager() {
  const { lang, api } = useApp();
  const zh = lang === "zh";
  return (
    <div className="space-y-4" data-testid="admin-branches-page">
      <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
        <Building2 className="h-6 w-6 text-brand-500" />{zh ? "分公司管理" : "Branches"}
      </h1>
      <BranchManagerPanel lang={lang} api={api} />
    </div>
  );
}
